import Link from 'next/link';
import type React from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useApp } from '@/forApp/states/appState/appState';
import fetcher from '@/forApp/utils/fetcher/fetcher';
import Button from '@/shared/Buttons/Button';
import Checkbox from '@/shared/Checkboxs/Checkbox';
import Input from '@/shared/Input/input';
import Modal from '@/shared/Modal/Modal';
import styles from './styles.module.css';
import { ROUTES } from '@/forApp/utils/routes';

type ConsultationModalT = {
  from: string;
  title: string;
};

interface FormData {
  surname: string;
  name: string;
  phone: string;
  from: string;
}

const ConsultationModal: React.FC<ConsultationModalT> = ({ title, from }) => {
  const { delModal, addNotification } = useApp();
  const [policyAgreed, setPolicyAgreed] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { isValid },
    reset,
  } = useForm<FormData>({
    defaultValues: {
      surname: '',
      name: '',
      phone: '',
      from: from,
    },
  });

  const closeModal = () => {
    reset();
    setPolicyAgreed(false);
    delModal();
  };

  const onSubmit = async (data: FormData) => {
    if (!policyAgreed) {
      return;
    }

    try {
      const response = await fetcher<{ success: boolean }>(
        'POST',
        '/feedbacks',
        {
          body: JSON.stringify(data),
        },
      );

      if (response.success) {
        closeModal();
        addNotification({
          text: 'Спасибо за заявку! Мы свяжемся с вами в ближайшее время.',
          type: 'success',
        });
      }
    } catch {
      addNotification({
        text: 'Произошла ошибка при отправке заявки',
        type: 'error',
      });
    }
  };

  return (
    <Modal
      title={title}
      description={'Оставьте заявку и мы свяжемся с вами в ближайшее время'}
    >
      <div className={styles.modalContent}>
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <div className={styles.formField}>
            <Input name="surname" control={control} placeholder="Фамилия" />
          </div>
          <div className={styles.formField}>
            <Input
              name="name"
              control={control}
              placeholder="Имя"
              rules={{ required: 'Номер телефона обязателен' }}
            />
          </div>
          <div className={styles.formField}>
            <Input
              name="phone"
              control={control}
              rules={{ required: 'Номер телефона обязателен' }}
              placeholder="Номер телефона"
              type="tel"
              mask="+7 (___) ___-__-__"
            />
          </div>
          <Button
            type="submit"
            text="Отправить"
            disabled={!policyAgreed || !isValid}
            className={styles.btnSubmit}
          />
        </form>
      </div>

      <div className={styles.modalFooter}>
        <Checkbox
          isChecked={policyAgreed}
          onChange={() => setPolicyAgreed(!policyAgreed)}
        />
        <span>
          Я согласен(а) с условиями{' '}
          <Link href={ROUTES.POLICY} target="_blank">
            Политики конфиденциальности
          </Link>{' '}
          и даю согласие на обработку персональных данных.{' '}
          <span style={{ color: 'red' }}>*</span>
        </span>
      </div>
    </Modal>
  );
};

export default ConsultationModal;
